const columns = [
    {
        label: "Nazwa",
        field: "name",
        width: 40
    },
    {
        label: "Dozwolone dla kaucji",
        field: "allowedForDeposit",
        width: 20,
        type: "boolean"
    }
];

export default columns; 